<div class="app-pin-recovery">
  <div class="pin-header-container">
    <div class="pin-header">FARM RUN</div>
    <div class="pin-sub-header">PIN RECOVERY</div>
    <div class="pin-description">กรุณากรอก PIN ของท่าน และไม่ควรบอกรหัสนี้กับบุคคลอื่น</div>
  </div>

  <form [formGroup]="pinForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12" *ngIf="recoveryStep === 2">
        <p>ยืนยันรหัส PIN อีกครั้ง</p>
      </div>
      <div class="col-12">
        <div class="pin-container">
          <input id="position_1" type="password" autocomplete="off" mask="9" class="input-pin" formControlName="position_1" />
          <input id="position_2" type="password" autocomplete="off" mask="9" class="input-pin" formControlName="position_2" />
          <input id="position_3" type="password" autocomplete="off" mask="9" class="input-pin" formControlName="position_3" />
          <input id="position_4" type="password" autocomplete="off" mask="9" class="input-pin" formControlName="position_4" />
        </div>
      </div>
      <div class="col-12">
        <div class="pin-action">
          <button type="button" class="btn btn-default" *ngIf="storePin" (click)="resetStorePin()">รีเช็ต PIN</button>
          <button type="submit" class="btn btn-primary">
            {{ recoveryStep === 1 ? 'ยืนยันรหัส PIN' : 'กู้คืนรหัส PIN' }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
